/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { Stack, Text, TextLink } from "@carrotfertility/carotene"
import { FormattedMessage } from "react-intl"

export function NoResultMessage({ isCountryCodeNotMatching }: { isCountryCodeNotMatching: boolean }): JSX.Element {
  return !isCountryCodeNotMatching ? <UnmatchedGeoText /> : <NoResultsText />
}

function UnmatchedGeoText(): JSX.Element {
  return (
    <Stack spacing="medium" width={363}>
      <Text color="black60" size="small">
        <FormattedMessage
          defaultMessage="We're adding new providers all the time, {br} so <TextLink>contact us</TextLink> and we'll help you connect to the provider you need."
          values={{
            br: <br />,
            TextLink: (textLinkContent) => (
              <TextLink color="black60" to="/talk-to-carrot/sendmessage/helpfindingprovider">
                {textLinkContent}
              </TextLink>
            )
          }}
        />
      </Text>
      <Text color="black60" size="small">
        <FormattedMessage defaultMessage="You may also want to try widening your search parameters." />
      </Text>
    </Stack>
  )
}

function NoResultsText(): JSX.Element {
  return (
    <Stack spacing="medium" width={363}>
      <Text color="black60" size="small">
        <FormattedMessage
          defaultMessage="That's because you're searching outside of the country where you're employed. {br}{br} Cross-border care is complex, so <TextLink>get in touch</TextLink> and {br}we'll help you connect to the provider you need."
          values={{
            br: <br />,
            TextLink: (chunks) => (
              <TextLink color="black60" to="/talk-to-carrot/sendmessage/helpfindingprovider">
                {chunks}
              </TextLink>
            )
          }}
        />
      </Text>
    </Stack>
  )
}
